<template>
  <div class="step-hours-cont">
    <el-skeleton :loading=isLoadingTabs animated class="hours-grid-cont">
      <template slot="template">
        <div class="button-group">
          <el-skeleton-item class="label-loading" />
          <div class="step-hours-button-cont">
            <el-skeleton-item class="hours-loading" animated v-for="n in 8" :key="n" />
          </div>
        </div>
      </template>
      <template>
        <div v-if="getAvailableTabs !== null" class="step-hours-selection-cont">
          <div class="button-group" v-for="services in getAvailableTabs" :key="services.name" :label="services.name"
            v-if="services.tabs.length > 0">
            <div v-if="services.type === 'event'" class="step-hours-label">{{ services.title }}</div>
            <div class="step-hours-button-cont">
              <el-tooltip v-for="tab in services.tabs" :key="tab.hour"
                :content="!tab.available ? `${tab.capacity} place${tab.capacity > 0 ? 's' : ''} disponible${tab.capacity > 0 ? 's' : ''}` : ''"
                placement="top" :disabled="tab.available">
                <el-button :disabled="!tab.available" :label="tab.hour" :value="tab.hour" class="step-hours-button"
                  @click="selectService({
                    hour: tab.hour,
                    serviceName: services.name,
                    cashOn: services.cashOn,
                    cashPrice: services.cashPrice,
                    cashCouv: services.cashCouv,
                    cashType: services.cashType,
                    discount: tab.discount,
                  })">
                  <div class="step-hours-button-hour">
                    {{ tab.hour }}
                  </div>
                  <div v-if="tab.discount" class="discount-badge">
                    <p>
                      -{{ tab.discount }}%
                    </p>
                  </div>
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
  name: 'HoursSelection',
  computed: {
    ...mapGetters({
      getAvailableTabs: 'forkBooking/getAvailableTabs',
      isLoadingTabs: 'forkBooking/isLoadingTabs'
    }),
    getServicesHoursData: function () {
      return this.tabHours
    }
  },
  methods: {
    selectService: function (val) {
      this.selectedService = val
      this.setSelectedService(val)
      this.setCurrentStep(3)
    },
    ...mapActions({
      setSelectedService: 'forkBooking/setSelectedService',
      setCurrentStep: 'forkBooking/setCurrentStep'
    })
  }
}
</script>

<style lang="scss">
.step-hours-dayClosed {
  color: #999;
}

.step-hours-label {
  text-transform: capitalize;
  align-self: self-start;
  padding: 3px 6px;
  border-radius: 4px;
}

.step-hours-cont {
  height: calc(100% - 117px);
  overflow-y: auto;

  .hours-loading {
    height: 40px;
    border-radius: 50px;
  }

  .label-loading {
    border-radius: 50px;
    height: 19px;
    width: 50px;
    margin-bottom: 7px;
  }

  .hours-grid-cont {
    padding: 16px;
  }

  .step-hours-button-cont {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;

    .is-disabled {
      .discount-badge {
        background-color: var(--color-bg) !important;

        p {
          color: var(--color-text) !important;
        }
      }
    }

    .step-hours-button {
      overflow: hidden;
      height: 40px;

      span {

        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 40px;
      }

      .step-hours-button-hour {
        height: 55%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .discount-badge {
        height: 45%;
        background-color: var(--color-primary);
        display: flex;
        justify-content: center;
        align-items: center;

        p {
          color: var(--color-primary-contrast);
          font-size: 11px;
          font-weight: 700;
          margin: 0;
        }
      }
    }

    button {
      margin: 0;
      padding: 0;
      height: 40px;
    }
  }

  .step-hours-selection-cont {
    display: flex;
    flex-direction: column;
    gap: 16px;


    .button-group:not(:last-child) {
      padding-bottom: 16px;
      border-bottom: 1px solid var(--color-border);
    }

    .button-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    button {
      border-radius: 50px;
    }
  }
}
</style>